import { fieldIsInvalid, fieldIsRequired, getValidationResult } from 'shared/utils/tools'
import uuid from 'uuid/v4'
import * as yup from 'yup'
import { Identifiable } from 'shared/types'

export interface Option {
  label: string;
  value: string;
}

export interface ScreeningQuestionType {
  // id: string,
  // text: string,
  // description: string[]

  id: string;
  label: string;
  type: string;
  section_text: string;
  options: Option[] | any;
}

export const screeningAnswer = yup.object().shape({
  question_id: yup.string()
    .required(),
  answer: yup.string()
})

export const screeningParticipant = yup.object().shape({
  id: yup.string()
    .required(),
  name: yup.string()
    .required(),
  isSelected: yup.boolean()
    .required(),
  question_count: yup.number()
    .required(),
  showScreening: yup.boolean()
    .required(),
  answers: yup.array()
    .of(screeningAnswer)
})

export const screeningForm = yup.object().shape({
  participants: yup.array()
    .of(screeningParticipant)
    .required()
})

export type ScreeningFormType = yup.InferType<typeof screeningForm>
export type ScreeningAnswerType = yup.InferType<typeof screeningAnswer>
export type ScreeningParticipantType = yup.InferType<typeof screeningParticipant>

export default function validator(data: ScreeningFormType) {
  return getValidationResult(data, screeningForm)
}

export function getEmptyScreeningForm(): ScreeningFormType {
  return {
    participants: [
      getEmptyParticipant(),
    ]
  }
}

export function getDummyQuestions(): ScreeningQuestionType[] {
  return []
  // return [
  //   {
  //     id: uuid(),
  //     description: [],
  //     text: `In the last 14 days, have you or anyone you live with traveled outside of Canada?`,
  //   },
  //   {
  //     id: uuid(),
  //     description: [],
  //     text: `In the last 14 days, have you had close contact with or have cared for someone diagnosed with COVID-19?`,
  //   },
  //   {
  //     id: uuid(),
  //     description: [],
  //     text: `Has a doctor, health care provider, or public health official told you that you should currently be isolating (staying at home)?`,
  //   },
  //   {
  //     id: uuid(),
  //     description: [],
  //     text: `In the last 14 days, have you received a COVID Alert exposure notification on your cell? If you already went for a test and got a negative result, select ‘No’.`,
  //   },
  //   {
  //     id: uuid(),
  //     text: `Do you have any of the following new or worsening symptoms or signs? Symptoms should not be chronic or related to other known causes or conditions:`,
  //     description: [
  //       'Body temperature above 37.5°C (and/or chills) (Please check temperature)',
  //       'Cough or barking cough (coup)',
  //       'Shortness of breath (out of breath, unable to breathe deeply)',
  //       'Decrease or loss of smell or taste',
  //       'Sore throat (painful swallowing or difficulty swallowing)',
  //       'Pink Eye',
  //       'Stuffy, congested or runny nose',
  //       'Headache (that is new and persistent, unusual, unexplained or long-lasting)',
  //       'Digestive issues like nausea, vomiting, stomach pain, diarrhea',
  //       'Muscle aches, that are unusual or long lasting',
  //       'Extreme tiredness that is unusual (general feeling of being unwell/unexplained lack of energy)',
  //       'Falling down often',
  //     ],
  //   },
  //   {
  //     id: uuid(),
  //     description: [],
  //     text: `Is anyone you live with currently experiencing any new COVID-19 symptoms and/or waiting for test results after experiencing symptoms and/or self-isolating?`,
  //   }
  // ]
}

export function getEmptyParticipant(): ScreeningParticipantType {
  return {
    id: uuid(),
    showScreening: false,
    name: '',
    isSelected: false,
    question_count: 0,
    answers: []
  }
}

export function getEmptyParticipant2(): ScreeningParticipantType {
  return {
    id: uuid(),
    showScreening: false,
    name: 'Shadow Tax',
    isSelected: false,
    question_count: 0,
    answers: []
  }
}
